// extracted by mini-css-extract-plugin
export default {"CreateQuiz":"CreateQuiz_CreateQuiz__zMOUn"};